import {WebPhotoManager} from "./HTMLPhotoManager";
import SoundManager from "./SoundManager";
import {NativeCallbacks} from "./Callbacks";

export default class Native {

    // photos
    public static cameraAllowed = () => {
        NativeCallbacks.fireCallback(Native.CB_CAMERA_ALLOWED, {allowed: true})
    };
    public static initCamera = () => true;
    public static startCamera = (skin, bgColor, album, idx) => {};
    public static deletePhoto = (album: string, idx: number) => {
        WebPhotoManager.deletePhoto(album, idx);
    };
    public static hasCamera = () => false;
    public static retrievePhotoUrls = (album: string) => {
        WebPhotoManager.retrievePhotoUrls(album);
    };

    public static readonly CB_CAMERA_CLOSED = "camera_closed";
    public static readonly CB_DELETE_PHOTO = "photo_deleted";
    public static readonly CB_GET_PHOTO_URLS = "retrieve_photo_urls_result";
    public static readonly CB_CAMERA_INIT = "camera_initialized";

    public static readonly CB_SPEAKER_VOLUME_RETRIEVED = "speaker_volume_retrieved";

    public static readonly CB_CAMERA_ALLOWED = "camera_allowed";
    public static readonly CB_MICROPHONE_ALLOWED = "microphone_allowed";

    public static isMobile = false;

    // storage

    public static getStorageString = (key) => {
        console.log('get storage string');
        return window.localStorage.getItem(key);
    }
    public static putStorageString = (key, value) => {
        console.log('put storage string');
        window.localStorage.setItem(key, value);
    }

    // ui

    public static exitGame = () => {
        console.log('Closing game');
    };
    public static isTablet = () => {
        console.log('isTablet()')
        return true;
    }
    public static isSoundEnabled = () => {
        console.log('isSoundEnabled()');
        return true;
    };

    // profiles

    public static getProfileAvatar = () => {
        console.log('getProfileAvatar')
        return 'AvatarChloe1';
    };
    public static getProfileName = () => {
        console.log('getProfileName')
        return 'Kidiyo';
    };

    // trophies

    public static addTrophy = (difficulty) => {
        console.log('add trophy');
    };
    public static openTrophyCabinet = (addPrize) => {
        console.log('Opening trophy cabinet for prize ' + addPrize);
    };

    public static doesMediaPlaybackRequireUserGesture = () => {
        console.log('doesMediaPlaybackRequireUserGesture');
        return false;
    };

    // audio recording

    public static microphoneAllowed = () => {
        console.log('microphoneAllowed');
        NativeCallbacks.fireCallback(Native.CB_MICROPHONE_ALLOWED, {allowed: true});
    };
    public static prepareForAudioRecording = () => {
        console.log('prepareForAudioRecording runs');

        // the correct way to handle this is probably to keep the stream
        // going the whole time we are playing the game via this function
        // and on `startAudioRecording` redirect the ongoing stream into
        // a variable until `stopAudioRecording` gets called or a timer
        // runs out.
        navigator.mediaDevices.getUserMedia({ audio: true })
        .then(function(stream) {
            console.log('allowed ');
            window.onRecordAudioIsAvailable(true);

            stream.getTracks().forEach(function(track) {
                track.stop();
            });
        })
        .catch(function(err) {
            console.log(' not allowed ');
            window.onRecordAudioIsAvailable(false);
        });

        window.onRecordAudioIsAvailable(false);
    };

    public static startAudioRecording = () => {
        console.log('startAudioRecording');

        navigator.mediaDevices.getUserMedia({ audio: true })
        .then(function(stream) {
            console.log('recording audio ');
            window.onRecordAudioIsAvailable(true);

            stream.getTracks().forEach(function(track) {
                track.stop();
            });

            window.onRecordedFileIsReady('cool file');
        })
        .catch(function(err) {
            console.log(' not allowed ');
            window.onRecordAudioIsAvailable(false);
        });
    };

    public static stopAudioRecording = () => {
        console.log('stopAudioRecording');
    };

    // audio playing
    public static playSound = (sound: string) => {
        console.log('playsound');
    };
    public static getVolume = () => {
        console.log('getVolume');
        NativeCallbacks.fireCallback(Native.CB_SPEAKER_VOLUME_RETRIEVED, {volume: 1.0});
    }
}

declare var window: any;


// WEBPACK FOOTER //
// ../lib/src/Native.ts